import { Component, input, computed, inject } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Router, ActivatedRoute } from '@angular/router';
import { OperativeResponse } from 'src/app/shared/interfaces/holidays.interface';

interface BottomCardItem {
  id: string;
  title: string;
  value: number;
  value2?: number;
  status: 'success' | 'warning' | 'error';
}

@Component({
  selector: 'app-operational-card',
  standalone: true,
  imports: [MatIconModule, MatSlideToggleModule, MatDividerModule],
  templateUrl: './operational-card.component.html',
  styleUrls: ['./operational-card.component.css', '../../../styles/layout.css'],
})
export class OperationalCardComponent {
  // input signal coming from the parent
  readonly operative = input<OperativeResponse | null>();

  // computed signal that returns an array suitable for @for
  readonly bottomItems = computed<BottomCardItem[]>(() => {
    const op = this.operative();
    if (!op) return [];
    const stats = op.stats;

    return [
      // {
      //   id: 'camiones',
      //   title: 'CAMIONES',
      //   value: stats?.camiones.actual || 0,
      //   value2: stats?.camiones.total || 0,
      //   status: stats?.camiones.status || 'success',
      // },
      {
        id: 'conductores',
        title: 'CONDUCTORES',
        value: stats?.conductores.actual || 0,
        value2: stats?.conductores.total || 0,
        status: stats?.conductores.status || 'success',
      },
      {
        id: 'notificaciones',
        title: 'NOTIFICACIONES',
        value: stats?.notificaciones_count ?? 0,
        status: (stats?.notificaciones_count ?? 0) > 0 ? 'error' : 'success',
      },
    ];
  });

  // computed signal for petition count
  readonly petitionCount = computed(() => {
    return this.operative()?.pending_petitions?.count ?? 0;
  });

  // computed signal for petition message
  readonly petitionMessage = computed(() => {
    return this.operative()?.pending_petitions?.message ?? 'No hay peticiones';
  });

  private route = inject(ActivatedRoute);

  constructor(private router: Router) {}

  goToOperational() {
    const op = this.operative();
    const exerciseId = this.route.snapshot.params['id'];
    const year = this.route.snapshot.params['year'];
    if (!op?.id || !exerciseId) return;

    this.router.navigate([
      '/home',
      'vacations',
      'drivers',
      'exercise',
      exerciseId,
      year,
      'operational',
      op.id,
    ]);
  }

  trackById(_index: number, item: BottomCardItem): string {
    return item.id;
  }
}
